import type { VoidFunctionComponent } from 'react';
import { useSelector } from 'react-redux';
import IssueGenericContent from './IssueGenericContent';
import type { IssueDetailsTab } from '../Tabs';
import Header from '../Quality/Header';
import Dependency from '../Quality/Dependency';
import IssueDetails from '../Quality/IssueDetails';
import * as IssuesV2Store from '../../../../redux/issuesV2';
import QualityIssueLoading from './Loading/QualityIssueLoading';
import IssueDetailsResolvedReason from '../ResolvedReason';

type QualityIssueDrawerContentProps = {
  activeTab: IssueDetailsTab;
  setActiveTab: (tab: IssueDetailsTab) => void;
};

/**
 * Displays the quality issue content in the issue drawer
 */
const QualityIssueContent: VoidFunctionComponent<QualityIssueDrawerContentProps> =
  ({ setActiveTab, activeTab }) => {
    const isLoadingIssueDetails = useSelector(IssuesV2Store.selectors.getIsLoadingIssueDetails);
    if (isLoadingIssueDetails) {
      return <QualityIssueLoading />;
    }

    return (
      <IssueGenericContent
        headerSlot={<Header />}
        contentSlot={
          <>
            <IssueDetailsResolvedReason />
            <IssueDetails />
            <Dependency />
          </>
        }
        setActiveTab={setActiveTab}
        activeTab={activeTab}
      />
    );
  };

export default QualityIssueContent;
